import vueComponentOptions from 'components/InputText.vue';

const TextInput = Vue.extend(vueComponentOptions);

module.exports = TextInput;
